import { render, staticRenderFns } from "./questionDailog.vue?vue&type=template&id=1a28c06c&scoped=true"
import script from "./questionDailog.vue?vue&type=script&lang=js"
export * from "./questionDailog.vue?vue&type=script&lang=js"
import style0 from "./questionDailog.vue?vue&type=style&index=0&id=1a28c06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28c06c",
  null
  
)

export default component.exports